export default __webpack_public_path__ + "65f9eee154281201f5951eb552273f2f.svg";